import { useState } from 'react';
import { toast } from 'sonner';

import { connectInstagramDirect } from '@/hooks/user';

export const useInstagramDirectPopup = () => {
  const [loading, setLoading] = useState(false);

  const openInstagramDirectPopup = async () => {
    setLoading(true);

    try {
      // Use the same endpoint pattern as Instagram.jsx
      const response = await connectInstagramDirect();

      // The endpoint returns redirect_url (same pattern as fbAuth)
      const redirectUrl = response.authorization_url;

      if (redirectUrl) {
        // Open popup window directly to OAuth URL (no iframe to avoid X-Frame-Options error)
        const popup = window.open(
          redirectUrl,
          'instagram-direct-connect',
          'width=600,height=700,scrollbars=yes,resizable=yes'
        );

        if (popup) {
          // Monitor popup for completion
          // The callback page (InstagramDirectCallback.jsx) handles status display and closing
          // We only need to detect when popup closes and redirect (only closes on success)
          const checkClosed = setInterval(() => {
            if (popup.closed) {
              clearInterval(checkClosed);
              setLoading(false);
              // Popup only closes on success, so redirect to Instagram Direct settings page
              window.location.reload();
            }
          }, 1000);
        } else {
          toast.error('Popup blocked. Please allow popups for this site.');
          setLoading(false);
        }
      } else {
        console.error('No redirect URL received from backend.');
        toast.error('Failed to get Instagram Direct connection URL');
        setLoading(false);
      }
    } catch (error) {
      console.error('Instagram Direct connection error:', error);
      toast.error('Failed to connect Instagram Direct. Please try again.');
      setLoading(false);
    }
  };

  return { openInstagramDirectPopup, loading };
};
